import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';

import styles from './MaskInput.css';

const IPropTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  info: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  mask: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  formatCharacters: PropTypes.object.isRequired,
};

const defaultProps = {
  className: '',
  error: null,
  info: '',
  placeholder: '',
  size: 30,
  name: '',
  label: '',
};

const MaskInput = (props) => {
  const propsToPass = { ...props };
  delete propsToPass.className;
  delete propsToPass.id;
  return (
    <div className={props.className}>
      {
        !!props.label &&
        <label
          className={styles.label}
          htmlFor={props.name}
        >
          {props.label}
        </label>
      }
      <MaskedInput
        mask={props.mask}
        placeholder={props.placeholder}
        size={props.size}
        formatCharacters={props.formatCharacters}
        className={styles.input}
        onChange={props.onChange}
      />
      {
        !!props.info &&
        <p className={styles.info}>
          &#128712; {props.info}
        </p>
      }
      {
        !!props.error &&
        <p className={styles.error}>
          {props.error}
        </p>
      }
    </div>
  );
};

MaskInput.propTypes = IPropTypes;
MaskInput.defaultProps = defaultProps;

export { MaskInput };



// WEBPACK FOOTER //
// ./src/common/mask-input/MaskInput.jsx